// NATIVE 

// INSTALLED 

// CUSTOM 
import { checkingPreload, unCheckingPreload } from '../loading';
import { activeTipoNovedadService, createTipoNovedadService, desactiveTipoNovedadService, 
     getAllTipoNovedadesByPaginateService, getAllTipoNovedadService, getDataCreateTipoNovedadService, getTipoNovedadDetailService, updateTipoNovedadDetailService } from '../../services/tiponovedad.service';
import { generateReportControlTimeService } from '../../services/reports.service';
import dayjs from 'dayjs';





  export const generateReportControlTime = (dataReport:any, percentaje: any): any => {

     return async( dispatch: any ) => {

         
          await dispatch( checkingPreload() );

          const dataSave = {
             from: dayjs(dataReport.from).format('YYYY-MM-DD'),
             to:   dayjs(dataReport.to).format('YYYY-MM-DD'),
             format: dataReport.format
          }

           console.log('dataReport dataSave')
          console.log(dataSave)
          const result = await  generateReportControlTimeService(dataSave, percentaje);


          dispatch( unCheckingPreload() );

          return result
          
        
    }

  }









